import React from 'react';

const StarRating = ({ openStar, messages, handleLike, userNote, setUserNote, loading }) => {
    if (!openStar.status) {
        return null;
    }

    return (
        <div className="star-conversation">
            <p>{openStar.messages}</p>
            {!openStar.starSuccess && (
                <div className="star-conversation-wrap">
                    <div className="action-like-item">
                        {messages[0].unsatisfied !== true && (
                            <p
                                className={
                                    `like ` +
                                    (messages[0].satisfied === true ? `active` : ``)
                                }
                                onClick={() =>
                                    handleLike({
                                        satisfied: 1,
                                        messageKey: 0,
                                        type: "starConversation",
                                    })
                                }
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    width="20px"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M10.286 3.594A1 1 0 0 1 11.2 3a3.4 3.4 0 0 1 3.4 3.4v2.2h3.523a2.6 2.6 0 0 1 2.594 2.99l-1.104 7.2A2.601 2.601 0 0 1 17.019 21H5.6A2.6 2.6 0 0 1 3 18.4v-5.6a2.6 2.6 0 0 1 2.6-2.6h1.75l2.936-6.606ZM7 12.2H5.6a.6.6 0 0 0-.6.6v5.6a.6.6 0 0 0 .6.6H7v-6.8ZM9 19v-7.588l2.792-6.281A1.4 1.4 0 0 1 12.6 6.4v3.2a1 1 0 0 0 1 1h4.539a.6.6 0 0 1 .6.69c0-.001 0 0 0 0l-1.104 7.2a.6.6 0 0 1-.6.51H9Z"
                                    ></path>
                                </svg>
                                <span className="text">Hài lòng</span>
                            </p>
                        )}
                        {messages[0].satisfied !== true &&
                            messages[0].unsatisfied !== true && (
                                <p
                                    className={
                                        `dislike ` +
                                        (messages[0].unsatisfied === true ? `active` : ``)
                                    }
                                    onClick={() =>
                                        handleLike({
                                            unsatisfied: 1,
                                            messageKey: 0,
                                            type: "starConversation",
                                        })
                                    }
                                >
                                    <svg
                                        viewBox="0 0 24 24"
                                        width="20px"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.714 20.406A1 1 0 0 1 12.8 21a3.4 3.4 0 0 1-3.4-3.4v-2.2H5.877a2.6 2.6 0 0 1-2.594-2.99l1.104-7.2A2.6 2.6 0 0 1 6.981 3H18.4A2.6 2.6 0 0 1 21 5.6v5.6a2.6 2.6 0 0 1-2.6 2.6h-1.75l-2.936 6.606ZM17 11.8h1.4a.6.6 0 0 0 .6-.6V5.6a.6.6 0 0 0-.6-.6H17v6.8ZM15 5v7.588l-2.792 6.281A1.4 1.4 0 0 1 11.4 17.6v-3.2a1 1 0 0 0-1-1H5.861a.6.6 0 0 1-.6-.69c0 .001 0 0 0 0l1.104-7.2a.6.6 0 0 1 .6-.51H15Z"
                                        ></path>
                                    </svg>
                                    <span className="text">Không hài lòng</span>
                                </p>
                            )}
                    </div>
                    {messages[0].unsatisfied === true &&
                        !openStar.starSuccess && (
                            <div className="star-conversation-note">
                                <textarea
                                    className="box-note-text"
                                    placeholder="Đánh giá thêm về cuộc trò chuyện"
                                    type="text"
                                    id="message-note"
                                    name="messageNote"
                                    value={userNote}
                                    onChange={(e) => setUserNote(e.target.value)}
                                    disabled={loading}
                                ></textarea>
                                <button
                                    className={`box-note-button`}
                                    onClick={() => { }}
                                    disabled={loading}
                                >
                                    Gửi
                                </button>
                            </div>
                        )}
                </div>
            )}
        </div>
    );
};

export default StarRating;
